import { RouteComponentProps } from "@reach/router";
import React from "react";

const NotAuthorized: React.FC<RouteComponentProps> = () => (
  <div className="NotAuthorized">
    <h1>You don&apos;t have permission to view this page</h1>
  </div>
);

export default NotAuthorized;
